module.exports = __webpack_public_path__ + "img/1a854f84bcc160dfb511e7187a8f12b4.png";